import cx from 'classnames'
import * as React from 'react'

import Button from '../../components/Button/Button'
import Heading from '../../components/Heading/Heading'
import Image from '../../components/Image/Image'
import Rte from '../../components/Rte/Rte'
import type { CtaViewModel } from '../../view-models/CtaViewModel'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import styles from './sidebarCtaBlock-style.css'

type Props = {
  image?: ImageViewModel
  heading?: string
  text?: string
  cta?: CtaViewModel
}
type State = {}

class SidebarCtaBlock extends React.Component<Props, State> {
  static displayName = 'SidebarCtaBlock'
  static defaultProps = {}

  render() {
    const { image, heading, text, cta } = this.props
    const eventMeta = {
      event: 'right-side-box-interaction',
    }

    return (
      <div className={styles.sidebarWithTextAndCta}>
        {image && <Image {...image} />}
        <div className={cx(styles.innerWrapper, !cta ? styles.noCta : '')}>
          {heading && (
            <Heading className={styles.heading} level={2} tag={'h3'}>
              {heading}
            </Heading>
          )}
          {text && <Rte className={styles.sidebarRte} source={text} />}
          {cta && <Button {...cta} {...cta.link} darkBg eventMeta={eventMeta} />}
        </div>
      </div>
    )
  }
}

export default SidebarCtaBlock